/**
 * Application entry point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';

import './api/interceptors';
import './styles/animations.scss';
import './styles/pageHeader.scss';
import App from './App';
import { errorReporting } from './services/errorReporting';

// Catch unhandled promise rejections outside React (event handlers, setTimeout, etc.)
window.addEventListener('unhandledrejection', (event) => {
  errorReporting.report({
    error: event.reason instanceof Error ? event.reason : new Error(String(event.reason)),
    context: { source: 'unhandledrejection' },
  });
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
